import { ReactElement } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { trackUserInteractionOnce } from '../../helpers/checkoutTracking';
import { Link } from 'dibs-elements/exports/Link';

export const getAgreementLink = (): ReactElement => (
    <Link href="/about/user-agreement/" target="_blank" onClick={trackUserInteractionOnce}>
        <FormattedMessage id="checkout.TermsLinks.agreement" defaultMessage="User Agreement" />
    </Link>
);

export const getPolicyLink = (): ReactElement => (
    <Link href="/about/privacy-policy/" target="_blank" onClick={trackUserInteractionOnce}>
        <FormattedMessage id="checkout.TermsLinks.policy" defaultMessage="Privacy Policy" />
    </Link>
);
